/**
 * MixerPanelWrapper Component
 * Wrapper for the MixerPanel with all its required props
 */

import React from 'react';
import { MixerPanel } from '../mixer';

export const MixerPanelWrapper = ({
  viewMode,
  tracks,
  masterVolume,
  selectedTrackId,
  // Track handlers
  handleMixerVolumeChange,
  handleMixerPanChange,
  handleMixerMuteToggle,
  handleMixerSoloToggle,
  setSelectedTrack,
  handleMixerNameChange,
  removeTrack, // NEW: Delete track handler
  setMasterVolume,
  // Effects handlers
  handleAddEffect,
  handleRemoveEffect,
  handleToggleEffect,
  handleReorderEffects,
  handleEffectParamChange,
  // Plugin handlers
  handleOpenTrackPluginBrowser,
  handleRemoveTrackPlugin,
  handleToggleTrackPluginBypass,
  handleReorderTrackPlugins,
  handleTrackPluginParamChange,
  handleOpenTrackPresets,
  // Guitar effects
  handleGuitarEffectsChange,
  expandedGuitarEffectsTrack,
  setExpandedGuitarEffectsTrack,
  // User
  userId,
  // Panel state
  showMixer,
  setShowMixer,
}) => {
  if (viewMode !== 'edit') return null;
  
  return (
    <MixerPanel
      tracks={tracks}
      masterVolume={masterVolume}
      selectedTrackId={selectedTrackId}
      onTrackVolumeChange={handleMixerVolumeChange}
      onTrackPanChange={handleMixerPanChange}
      onTrackMuteToggle={handleMixerMuteToggle}
      onTrackSoloToggle={handleMixerSoloToggle}
      onTrackSelect={setSelectedTrack}
      onTrackNameChange={handleMixerNameChange}
      onRemoveTrack={removeTrack}
      onMasterVolumeChange={setMasterVolume}
      onAddEffect={handleAddEffect}
      onRemoveEffect={handleRemoveEffect}
      onToggleEffect={handleToggleEffect}
      onReorderEffects={handleReorderEffects}
      onEffectParamChange={handleEffectParamChange}
      onAddPlugin={(trackId) => handleOpenTrackPluginBrowser(trackId)}
      onRemovePlugin={handleRemoveTrackPlugin}
      onTogglePluginBypass={handleToggleTrackPluginBypass}
      onReorderPlugins={handleReorderTrackPlugins}
      onPluginParamChange={handleTrackPluginParamChange}
      onOpenPluginBrowser={handleOpenTrackPluginBrowser}
      onOpenTrackPresets={handleOpenTrackPresets}
      onGuitarEffectsChange={handleGuitarEffectsChange}
      expandedGuitarEffectsTrack={expandedGuitarEffectsTrack}
      onToggleGuitarEffectsExpand={(trackId) => setExpandedGuitarEffectsTrack(
        expandedGuitarEffectsTrack === trackId ? null : trackId
      )}
      userId={userId}
      isOpen={showMixer}
      onToggle={() => setShowMixer(!showMixer)}
    />
  );
};

export default MixerPanelWrapper;
